import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Box, Collapse, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import React, { MouseEventHandler, useState, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import style from "./style.module.scss";

interface ItemProps {
  icon?: JSX.Element;
  text: string;
  link: string;
  children?: React.ReactNode;
  className?: string;
  index?: number;
  readOnly?: boolean;
  trial?: boolean;
  onClick?: MouseEventHandler;
}

const Item = forwardRef((props: ItemProps, ref: any) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    // Prevent default only for left-clicks (not Ctrl/Cmd+Click, middle-click, or right-click)
    if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();

      if (props.trial) {
        props.onClick && props.onClick(e);
      } else {
        if (props.readOnly) return;
        props.onClick && props.onClick(e);
        setOpen(!open);
        navigate(props.link);
      }
    }
  };

  return (
    <ListItemButton
      {...props}
      ref={ref}
      component="a"
      href={props.link}
      onClick={handleClick}
      className={props.className}
    >
      <ListItemIcon className={style.icon}>{props.icon}</ListItemIcon>
      <ListItemText className={style.text} primary={props.text} />
      {props.children ? (
        open ? (
          <ExpandLess sx={{ width: "16px", height: "16px", color: "text.fontLight2" }} />
        ) : (
          <ExpandMore sx={{ width: "16px", height: "16px", color: "text.fontLight2" }} />
        )
      ) : null}
    </ListItemButton>
  );
});

export default Item;
